import { render, staticRenderFns } from "./QuizResultKnowledgeUnit.vue?vue&type=template&id=117808ae&"
import script from "./QuizResultKnowledgeUnit.vue?vue&type=script&lang=js&"
export * from "./QuizResultKnowledgeUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports